export default __webpack_public_path__ + "static/media/mumzworld.7da1f1aa.png";